import { createVueInstance } from '../utils'
import Toast from './_toast'
export default createVueInstance(Toast)



// WEBPACK FOOTER //
// ./src/components/toast.js